import { marker as t } from '@biesbjerg/ngx-translate-extract-marker';

import {
  ItemOf,
  DataService,
  BulkAction,
  ModalService,
  NotificationService,
} from '@vendure/admin-ui/core';

import { EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import {
  GetBannersQuery,
  DeleteBannersDocument,
  GetBannerItemsQuery,
  DeleteBannerItemsDocument,
} from '../../gql/graphql';
import { BannerListComponent } from './banner-list/banner-list.component';

export const DeleteBannersBulkAction: BulkAction<
  ItemOf<GetBannersQuery, 'banners'>,
  BannerListComponent
> = {
  location: 'banner-list',
  label: t('grupo-loja.remove-banner'),
  icon: 'trash',
  iconClass: 'is-danger',
  requiresPermission: userPermissions =>
    userPermissions.includes('UpdateBanner'),
  onClick: ({ injector, selection, clearSelection, hostComponent }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    modalService
      .dialog({
        title: t('grupo-loja.confirm-bulk-delete-banners'),
        translationVars: {
          count: selection.length,
        },
        buttons: [
          { type: 'secondary', label: t('common.cancel') },
          { type: 'danger', label: t('common.delete'), returnValue: true },
        ],
      })
      .pipe(
        switchMap(response =>
          response
            ? dataService.mutate(DeleteBannersDocument, {
                input: selection.map(e => e.id),
              })
            : EMPTY,
        ),
      )
      .subscribe(result => {
        const deleted = result.deleteBanners;
        const errors: string[] = [];

        if (0 < deleted) {
          notificationService.success(
            t('grupo-loja.notify-bulk-delete-banner-success'),
            {
              count: deleted,
            },
          );
        }

        if (0 < errors.length) {
          notificationService.error(errors.join('\n'));
        }

        hostComponent.refresh();
        clearSelection();
      });
  },
};

export const DeleteBannerItemsBulkAction: BulkAction<
  ItemOf<GetBannerItemsQuery, 'bannerItems'>,
  BannerListComponent
> = {
  location: 'banner-item-list',
  label: t('grupo-loja.remove-banner-item'),
  icon: 'trash',
  iconClass: 'is-danger',
  requiresPermission: userPermissions =>
    userPermissions.includes('UpdateBannerItem'),
  onClick: ({ injector, selection, clearSelection, hostComponent }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    const notificationService = injector.get(NotificationService);
    modalService
      .dialog({
        title: t('grupo-loja.confirm-bulk-delete-banner-items'),
        translationVars: {
          count: selection.length,
        },
        buttons: [
          { type: 'secondary', label: t('common.cancel') },
          { type: 'danger', label: t('common.delete'), returnValue: true },
        ],
      })
      .pipe(
        switchMap(response =>
          response
            ? dataService.mutate(DeleteBannerItemsDocument, {
                input: selection.map(e => e.id),
              })
            : EMPTY,
        ),
      )
      .subscribe(result => {
        const deleted = result.deleteBannerItems;
        const errors: string[] = [];

        if (0 < deleted) {
          notificationService.success(
            t('grupo-loja.notify-bulk-delete-banner-item-success'),
            {
              count: deleted,
            },
          );
        }

        if (0 < errors.length) {
          notificationService.error(errors.join('\n'));
        }

        hostComponent.refresh();
        clearSelection();
      });
  },
};
